import React from 'react';
import useFadeIn from '../hooks/useFadeIn';

const services = [
  {
    num: '01',
    name: 'Custom Software Development',
    desc: 'From concept to production — web apps, mobile products, and enterprise systems engineered to your exact specifications. We own the full stack.',
  },
  {
    num: '02',
    name: 'Cloud Computing',
    desc: 'Architecture, migration, and management across AWS, GCP, and Azure. We design for resilience, cost-efficiency, and scale from day one.',
  },
  {
    num: '03',
    name: 'Data Analytics & AI',
    desc: 'Data pipelines, dashboards, ML models, and LLM integrations. We turn noise into signal and signal into decisions that move the needle.',
  },
  {
    num: '04',
    name: 'Cybersecurity',
    desc: 'Zero-trust frameworks, penetration testing, SOC-as-a-service, and compliance automation. Because security is not a feature — it is a foundation.',
  },
];

export default function Services() {
  const [ref, visible] = useFadeIn(0.05);

  return (
    <section id="services" className="services">
      <div className="services__inner">
        <div className="services__head">
          <div>
            <span className="section-label">What We Do</span>
            <h2 className="services__title">
              Craft at every<br /><em>layer.</em>
            </h2>
          </div>
          <p className="services__intro">
            We are not a generalist agency. Every service we offer is backed by deep
            expertise, battle-tested methodology, and a team that takes ownership.
            We build things we are proud to put our name on.
          </p>
        </div>

        <div ref={ref} className={`services__list fade-hidden ${visible ? 'fade-visible' : ''}`}>
          {services.map((s, i) => (
            <div key={i} className="service-row">
              <span className="service-row__num">{s.num}</span>
              <div className="service-row__body">
                <h3 className="service-row__name">{s.name}</h3>
                <p className="service-row__desc">{s.desc}</p>
              </div>
              <span className="service-row__arrow">→</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
